// state.js

const state = {
  isLoggedIn: false,
  user: null,
  error: null,
  isLoading: false,
};

export default state;
